import $ from 'jquery';
import registerCardExpiryRule from './CardExpiryRule';

// This module is the entry point of custom validations registration
registerCardExpiryRule();

$.validator.setDefaults({
    focusInvalid: false,
});
